import React from 'react';
import Notices from '../components/Notices';

const NoticesPage = () => {
  return (
    <div className="page-container" style={{ maxWidth: '1200px', padding: 0 }}>
      <Notices />
    </div>
  );
};

export default NoticesPage;
